// extracted by mini-css-extract-plugin
export default {"development":"Development_development__eaR6w","alert":"Development_alert__uww9b","error":"Development_error__8w0tO"};